<script setup lang="ts">
// Remember to disable the middleware protection from your page!
definePageMeta({
  auth: { unauthenticatedOnly: true, navigateAuthenticatedTo: '/students' }
})

const { signIn } = useAuth()
</script>

<template>
  <div>
    <UButton @click="signIn('google')">
      Google ile giriş yap
    </UButton>
  </div>
</template>